import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { User } from '../configuration-management/models/user.interface';
import { ConnectionService } from './offline-detection';
import { ConfigLoaderService } from '../config-loader.service';
import { storage } from '../shared/local-storage/local-storage.service';
import {LocalStorageNames} from "../shared/local-storage/local-storage.enum";

@Injectable()
export class BaseService {

    public currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    isConnected = true;
    public onlineEvent: Observable<Event>;
    public offlineEvent: Observable<Event>;
    public subscriptions = new Subscription();
    public connectionStatusMessage: string;
    public connectionStatus: string;
    constructor(
        protected http: HttpClient,
        private connectionService: ConnectionService,
        private configService: ConfigLoaderService
    ) {
      this.currentUserSubject = new BehaviorSubject<User>(storage.getItem<User>('currentUser', null));
      this.currentUser = this.currentUserSubject.asObservable();
      this.connectionService.monitor().subscribe(currentState => {
            if (currentState.hasNetworkConnection && currentState.hasInternetAccess) {
              this.isConnected = true;
            } else {
              this.isConnected = false;
            }
          });
      this.subscriptions.add(this.currentUserSubject.subscribe(res => {
          storage.setItem(LocalStorageNames.CurrentUser, res);
        }
      ));
    }

    headers() {
        return { headers: new HttpHeaders({ 'Content-Type': 'application/json',  }) };
    }

    fileHeaders() {
        return {
            responseType: 'blob',
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', })
        } as any;
    }

    excelFileHeaders() {
      return {
          headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*', })
      } as any;
  }

    protected get apiUrl(): string {
        return this.configService.config.apiUrl;
    }



}
